import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import "./ExpesselistMapComponent.scss";
const ExpensesListMapComponentDrag = ({ name, value, Setfunction, HighlightData, handleDragEnd }) => {
  return (
    <div className="AvailableExpenseList">
      <p className="Expense_Heading">{name}</p>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="expenses">
          {(provided) => (
            <div
              className="AvailableExpenseList_subdiv"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {value?.map((el, i) => (
                <Draggable key={el._id || i} draggableId={el._id || i.toString()} index={i}>
                  {(provided, snapshot) => (
                    <p
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      onClick={() => Setfunction(i)}
                      className={`tableRow-column-mangemenet dragdivbeautidaldnd ${
                        snapshot.isDragging ? "column_dragging_modal" : ""
                      }`}
                      style={{
                        backgroundColor: HighlightData === i ? "#CCCCCC" : "",
                        ...provided.draggableProps.style,
                        padding: "8px",
                        margin: "4px 0",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        cursor: "move",
                        userSelect: "none",
                      }}
                    >
                      {el.Name || el.Page_Name || el.Field_Title || el.Field_Label}
                    </p>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default ExpensesListMapComponentDrag;
